import Vue from 'vue';
import Vuex from 'vuex';
// import createLogger from 'vuex/dist/logger';
import modules from './modules';
import data from './data';
import pathify from 'vuex-pathify';
import authPlugin from './plugins/auth';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    ...modules,
    ...data
  },
  plugins: [pathify.plugin, authPlugin]
});
